var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Notification'),_vm._ssrNode(" "),_vm._ssrNode("<div id=\"blank_layout\">","</div>",[_c('nuxt',{key:_vm.route.fullPath})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }